<template>
    <div class="min_box">
        <p style="margin-bottom: 15px;color: rgba(0,0,0,.65)">统计周期</p>
        <Seach @dateChang="dateChang " @typeChang="typeChang " :typeNum="num"></Seach>
        <div class="flex">

            <div class="list_box">
                <div class="top">
                    <p class="list flex" ><span>浏览次数</span> <span><i>{{traffic.pv_total}}</i>  PV</span></p>
                    <p class="list flex" ><span>独立访客</span> <span><i>{{traffic.uv_total}}</i>  UV</span></p>
                </div>
                <p class="title2">访客来源</p>
                <p class="list flex" v-for="(item,index) in list"><span>{{item.type}}</span> <span>{{item.num}}</span></p>
            </div>
            <div class="chart" >
                <div class="title">访客来源</div>
                <CakeChart  :data="datas" :id="ids"></CakeChart>
            </div>
        </div>

    </div>
</template>

<script>
    import Seach from "../components/seach"
    import CakeChart from "../components/cakeChart"
    import API from "./api";
    export default {
        name: "flow",
        data(){
            return{
                num:"2",
                id: this.$route.query.id,
                datas:[],
                list:[],
                traffic:[{pv_total:""},{uv_total:""}],
                ids:"sourcea"
            }
        },
        components:{Seach,CakeChart},
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/SourceVisitors"; //设置左侧导航2-2 active
        },
        methods:{
            dateChang(data){
                this.getDetail("",data)
                this.num=""
            },
            typeChang(data){
                this.getDetail(data,"")
                this.num=data
            },
            getDetail(type,date) {
                API.service.SOURCE_GET_LIST({id:this.id,type:date?"":type||2,search_time:date}).then(res => {
                    this.datas=res.data.data.data
                    this.list=res.data.data.data
                    this.traffic=res.data.data.traffic
                })
            }
        },
        mounted() {
            this.getDetail()
            // this.typeChang
        }

    }
</script>

<style scoped>
    .title{font-weight: bold;font-size:18px;margin-bottom: 20px}
    .chart{margin-top:40px;width: 60%;position: relative;left: 10px}
    .list_box{border: 1px solid #f1f1f1;padding: 10px 16px;box-sizing: border-box;margin-top:40px;width: 38%}
    .list_box .list{line-height: 2;color: rgba(0, 0, 0, 0.65);width: 100%;}
    .list_box .top{border-bottom: 1px solid #f1f1f1;margin-bottom: 20px}
    .list_box .top i{color:#3a5a97}
    .list_box .title2{text-align: center;color: #3a5a97;font-weight: bold}
    .min_box{width: 70%}
</style>
